/**
 * PlantillasManager.js
 *
 * Plantillas de mensaje como sección propia del menú lateral (pedido de Angelo,
 * 2026-08-09: "que las plantillas tengan su propio espacio en el sidebar").
 *
 * No reimplementa nada: monta el mismo `TemplatesModal` de WorkflowsManager en
 * modo `embedded`. Ese componente ya tiene toda la lógica de adjuntos, valores
 * personalizados y CRUD; tener una segunda copia para la vista de página sería
 * garantizar que las dos se separen con el primer cambio.
 *
 * Lo único que agrega este archivo es la carga de datos, que antes hacía
 * WorkflowsManager como parte de su `loadReferenceData`.
 */

import React, { useState, useEffect, useCallback } from 'react';
import apiClient from '../../utils/apiClient';
import { TemplatesModal } from './WorkflowsManager';
import { Lock } from 'lucide-react';

const PlantillasManager = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(true);

  const load = useCallback(async () => {
    try {
      const res = await apiClient.get('/api/pos/crm/message-templates');
      setTemplates(res.data || []);
      setHasAccess(true);
    } catch (err) {
      // Mismo gate que el resto del CRM: si la cuenta no tiene el módulo, el
      // backend responde 403 y acá se muestra el aviso en vez de una lista
      // vacía que parece un error del sistema.
      if (err.response?.status === 403) setHasAccess(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="p-8 text-center text-gray-500">Cargando plantillas...</div>;

  if (!hasAccess) {
    return (
      <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
        <Lock className="w-16 h-16 text-gray-300 mb-4" />
        <h2 className="text-xl font-bold text-gray-700 mb-2">Plantillas no está incluido en tu plan</h2>
        <p className="text-gray-500 max-w-md">
          Las plantillas de mensaje son parte del módulo CRM. Contacta a soporte para activarlo.
        </p>
      </div>
    );
  }

  return <TemplatesModal templates={templates} embedded onChanged={load} onClose={() => {}} />;
};

export default PlantillasManager;
